import { Action } from '@ngrx/store';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { AppState } from '..';

export enum FormSchemaActionTypes {
    FetchFormSchema = '[APS] Fetch Configurations',
    LoadFormSchema = '[APS] Load Configurations',
    FetchDropdownOptions = '[APS] Fetch DropdownOptions',
    LoadDropdownOptions = '[APS] Load DropdownOptions',
}

export class FetchFormSchema implements Action {
    readonly type = FormSchemaActionTypes.FetchFormSchema;
    constructor(public id: string) { }
}

export class LoadFormSchema implements Action {
    readonly type = FormSchemaActionTypes.LoadFormSchema;
    constructor(public payload: AppState['form_schema']) { }
}

export class FetchDropdownOptions implements Action {
  readonly type = FormSchemaActionTypes.FetchDropdownOptions;
  constructor() { }
}

export class LoadDropdownOptions implements Action {
  readonly type = FormSchemaActionTypes.LoadDropdownOptions;
  constructor(public payload: any) { }
}


export type FormSchemaAction =
  | FetchFormSchema
  | LoadFormSchema
  | FetchDropdownOptions
  | LoadDropdownOptions
;
